type ValueOf<T> = T[keyof T];

const Placements = {
  TEASER: 'teaser',
  PRESCREEN: 'prescreen',
  SLIDE_UP: 'slide-up',
  CONTROL_MESSAGE: 'control-message',
  CONTROL_CARD: 'control-card',
} as const;

type Placement = ValueOf<typeof Placements>;

export default Placements;
export { Placement };
